
export default function HeroSection() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(92, 26, 36, 0.7), rgba(92, 26, 36, 0.7)), url('https://static.readdy.ai/image/50171caa7fe9961724fd6c723691a199/bc687a0dc703e2886114812db38d5c46.jpeg')`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
          Excelência que nasce da integração entre engenharia e arquitetura.
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl font-light max-w-3xl mx-auto leading-relaxed mb-8">
          Unimos estética e técnica para criar espaços sofisticados, funcionais e totalmente personalizados.
        </p>
        
        <a
          href="https://api.whatsapp.com/send/?phone=5511980341891&text=Ol%C3%A1%21+Gostaria+de+saber+mais+sobre+os+servi%C3%A7os+da+P&type=phone_number&app_absent=0"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center bg-[#5C1A24] text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-[#4A1520] transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-line mr-3 text-xl text-white"></i>
          Solicite um orçamento
        </a>
      </div>
    </section>
  );
}
